import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Badge, Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { RiEditFill } from "react-icons/ri";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import EditBadgeModal from "../../Components/Modals/EditBadgeModal.js";
import {
  useDeleteBadgeMutation,
  useGetAllBadgeQuery,
  useUpdateBadgeMutation,
} from "../../Data/services/badgesApi.js";
import {
  useDeleteCategoryMutation,
  useUpdateCategoryMutation,
} from "../../Data/services/categoryApi.js";
import { getCriteriaType } from "../../Helper/index.js";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
// import { useDeleteBusinessTypeMutation, useGetAllBusinessTypeMutation, useGetAllBusinessTypeQuery } from "../../Data/services/businessTypeApi.js";
// import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// const CustomerBlockModal = lazy(() =>
//   import("../../Components/Modals/CustomerBlockModal.js")
// );

const BadgeManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllBadgeQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  const [selectedType, setSelectedType] = useState(10);
  const typeList = [
    { label: "Order", value: 10 },
    { label: "Review", value: 20 },
  ];

  const [update, { isLoading: updating }] = useUpdateBadgeMutation();

  const handleDynamicTypeChange = async (value, row) => {
    console.log(value);
    console.log(row);
    setSelectedType(value);

    const data = {
      name: row.name,
      description: row.description,
      criteria_type: value, // default to 10 if not selected
      criteria_value: row.criteriaValue,
      level: row.level,
      icon_url: row.icon_url,
    };

    try {
      const response = await update({
        data: data,
        id: row.id,
      }).unwrap();
      console.log(response);

      if (response.code === 200) {
        refetch();
        SuccessToast(response?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deleteBadge, { isLoading: isDeleting }] = useDeleteBadgeMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteBadge(slug);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Badge Name",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "icon_url",
      text: "Image",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        // return row.firstname + row.lastname;
        return (
          <img
            alt="user"
            src={cellContent || "images/no_image_available.png"}
            loading="lazy"
            width={62}
            height={62}
            className="rounded-circle object-fit-cover"
          />
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      headerAlign: "center",
      align: "center",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className="lc-2">
            {cellContent ? cellContent : "No description available"}
          </span>
        );
      },
    },
    {
      dataField: "criteria_type",
      text: "Type",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          // <Badge pill bg={"success"} className="fs-6">
          //   {getCriteriaType(cellContent)}
          // </Badge>
          <SelectFieldComponent
            classes={`m-0 py-2 border-0 pointer hover-border ${
              cellContent === 10 ? "bg-danger-subtle" : "bg-info-subtle"
            }`}
            firstOption={getCriteriaType(cellContent)}
            optionsList={typeList}
            onSelectChange={(value) => handleDynamicTypeChange(value, row)}
          />
        );
      },
    },
    {
      dataField: "criteria_value",
      text: "Value",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge pill bg={"secondary"} className="fs-6">
            {cellContent}
          </Badge>
        );
      },
    },
    {
      dataField: "level",
      text: "Level",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge pill bg={"danger"} className="fs-6">
            {cellContent}
          </Badge>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Edit Category"}>
                <div
                  className={` d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 `}
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleEditModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-center `}
                  >
                    <RiEditFill />
                  </span>
                  {/* <span>Edit</span> */}
                </div>
              </ToolTip>

              <ToolTip placement={"top"} content={"Delete Category"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                  {/* <span>Delete</span> */}
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditBadgeModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Badge Management"} classes="text-black" />
        </div>

        {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Badge"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        }
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default BadgeManagementScreen;
